import { cn } from '@/lib/cn'

/**
 * La marca de PayBae es la propia Barra de Compromiso: tres trazos y, abajo,
 * los cuatro tramos en que se parte el dinero. El elemento que estructura la
 * app por dentro también la identifica por fuera.
 *
 * Los colores van fijos, no ligados al tema. Un logo que cambia de color según
 * el modo deja de ser reconocible, y además los tonos claros de la paleta
 * oscura perderían contraste sobre el fondo de la marca. Es el único lugar de
 * la app donde hay hex a mano, y es a propósito.
 */


export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={cn('size-9', className)} role="img" aria-label="PayBae">
      <rect width="64" height="64" rx="14" fill="#101b3b" />
      <rect x="12" y="20" width="40" height="6" rx="3" fill="#4a5a8f" />
      <rect x="12" y="30" width="25" height="6" rx="3" fill="#4a5a8f" />
      <rect x="12" y="40" width="5" height="6" rx="3" fill="#7c8aa8" />
      <rect x="19" y="40" width="5" height="6" rx="3" fill="#f4593f" />
      <rect x="26" y="40" width="5" height="6" rx="3" fill="#12b886" />
      <rect x="33" y="40" width="19" height="6" rx="3" fill="#3d50e0" />
    </svg>
  )
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <Logo />
      <span className="font-display text-xl font-bold tracking-[-0.03em] text-ink">PayBae</span>
    </div>
  )
}
